module.exports = __webpack_public_path__ + "static/media/persons-lg.144bcd51.png";